const carouselData = [
  {
    file: 'airfare',
    alt: 'Airfare',
    desc: 'Round Trip Honeymoon Airfare',
  },
  {
    file: 'home',
    alt: 'Home',
    desc: 'Home Down Payment',
  },
  {
    file: 'charity',
    alt: 'Charity',
    desc: 'Our Favorite Charity',
  },
  {
    file: 'avocados',
    alt: 'Avocados',
    desc: 'Lifetime Supply of Avocados',
  },
  {
    file: 'mlb',
    alt: 'MLB Season Tickets',
    desc: 'MLB Season Tickets',
  },
  {
    file: 'corgi',
    alt: 'Corgi Fund',
    desc: 'Corgi Fund',
  },
  {
    file: 'brunch',
    alt: 'Honeymoon Brunch for Two',
    desc: 'Honeymoon Brunch for Two',
  },
  {
    file: 'museum',
    alt: 'Art Museum Membership',
    desc: 'Art Museum Membership',
  },
  {
    file: 'snorkeling',
    alt: 'Snorkeling for Two',
    desc: 'Snorkeling for Two',
  },
  {
    file: 'kitchen',
    alt: 'Remodeling Our Kitchen',
    desc: 'Remodeling Our Kitchen',
  },
  {
    file: 'backpacking',
    alt: 'Backpacking Gear',
    desc: 'Backpacking Gear',
  },
  {
    file: 'pizza',
    alt: 'Saturday Night Pizza Fund',
    desc: 'Saturday Night Pizza Fund',
  },
];

export default carouselData;
